module.exports = __webpack_public_path__ + "img/astronaut.6b2c82b9.svg";